import { render, staticRenderFns } from "./StatusSelectbox.vue?vue&type=template&id=9ecd0a56"
import script from "./StatusSelectbox.vue?vue&type=script&lang=js"
export * from "./StatusSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports